import React from 'react';

import AdminSelect from '../../../../shared-components/AdminSelect/AdminSelect';
import styles from './CampaignList.module.css';

const CampaignList = ({
  campaigns,
  selectedCampaign,
  handleChangeCampaign,
}) => {
  return (
    <div className={styles.container}>
      <AdminSelect
        name="campaign"
        label="Select a campaign to view its categories:"
        list={campaigns}
        selected={selectedCampaign}
        selectLabel="Select"
        handleChange={handleChangeCampaign}
        style={{ width: 264 }}
      />
    </div>
  );
};

export default CampaignList;
